(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-finder"] && !Shopify.designMode) return;
  try {
    
  class ProductFinder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-finder-config]').textContent);
      this.labels = this.config.labels;
      this.state = {};
      this.history = [];
      this.products = [];
      this.flavorMap = new Map();
      this.flavorMode = 'flavor';
      this.step = this.querySelector('[data-finder-step]');
      this.results = this.querySelector('[data-finder-results]');
      this.status = this.querySelector('[data-finder-status]');
      this.choices = this.querySelector('[data-step-choices]');
      this.actions = this.querySelector('[data-step-actions]');
      this.backButton = this.querySelector('[data-finder-back]');
      this.resetButton = this.querySelector('[data-finder-reset]');
      this.summary = this.querySelector('[data-finder-summary]');
      this.liveCount = this.querySelector('[data-live-count]');
      this.progressFill = this.querySelector('[data-progress-fill]');
      this.progressText = this.querySelector('[data-progress-text]');
      this.rangePanel = this.querySelector('[data-step-range]');
      this.flavorModeControl = this.querySelector('[data-flavor-mode]');
      this.choiceSearchWrap = this.querySelector('[data-choice-search-wrap]');
      this.choiceSearch = this.querySelector('[data-choice-search]');
      this.rangeMin = this.querySelector('[data-range-min]');
      this.rangeMax = this.querySelector('[data-range-max]');
      this.backButton.addEventListener('click', () => this.goBack());
      this.resetButton.addEventListener('click', () => this.reset());
      this.querySelector('[data-empty-back]').addEventListener('click', () => this.goBack());
      this.rangeMin.addEventListener('input', () => this.syncRange('min'));
      this.rangeMax.addEventListener('input', () => this.syncRange('max'));
      this.querySelector('[data-step-all]').addEventListener('click', () => this.skipStep());
      this.querySelector('[data-step-continue]').addEventListener('click', () => this.commitStep());
      this.flavorModeControl.querySelectorAll('[data-flavor-mode-value]').forEach((button) => {
        button.addEventListener('click', () => this.setFlavorMode(button.dataset.flavorModeValue));
      });
      this.choiceSearch.addEventListener('input', () => this.filterChoices());
      this.loadProducts();
    }

    async loadProducts() {
      try {
        if (!this.dataset.productsUrl) throw new Error(this.labels.catalogError);
        this.flavorMap = await this.loadFlavorMap();
        const products = [];
        const seen = new Set();
        for (let page = 1; page <= 20; page += 1) {
          const url = new URL(this.dataset.productsUrl, window.location.origin);
          url.searchParams.set('limit', '250');
          url.searchParams.set('page', String(page));
          const response = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(this.labels.catalogError);
          const data = await response.json();
          const batch = data.products || [];
          batch.forEach((product) => {
            if (seen.has(product.id)) return;
            seen.add(product.id);
            products.push(product);
          });
          if (batch.length < 250) break;
        }
        this.products = products.map((product) => this.hydrateProduct(product));
        if (!this.products.length) throw new Error(this.labels.emptyCatalog);
        this.status.hidden = true;
        this.render();
      } catch (error) {
        this.status.innerHTML = '';
        this.status.textContent = error.message || this.labels.catalogError;
      }
    }

    parseFlavorPage(root) {
      const script = root.querySelector('[data-flavor-page]');
      if (!script) return { currentPage: 1, totalPages: 1, products: [] };
      return {
        currentPage: Number(script.dataset.currentPage || 1),
        totalPages: Number(script.dataset.totalPages || 1),
        products: JSON.parse(script.textContent),
      };
    }

    async loadFlavorMap() {
      const initial = this.parseFlavorPage(this);
      const pages = [initial];
      const requests = [];
      for (let page = 1; page <= initial.totalPages; page += 1) {
        if (page === initial.currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('page', String(page));
        requests.push(
          fetch(url, { headers: { Accept: 'text/html' } }).then(async (response) => {
            if (!response.ok) throw new Error(this.labels.catalogError);
            const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
            return this.parseFlavorPage(documentFragment);
          }),
        );
      }
      pages.push(...await Promise.all(requests));
      const map = new Map();
      pages.flatMap((page) => page.products).forEach((product) => {
        map.set(product.handle, {
          flavor: this.unique(product.flavors || []),
          taste: this.unique(product.tastes || []),
        });
      });
      return map;
    }

    normalize(value) {
      return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    }

    slug(value) {
      return this.normalize(value).replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }

    labelize(value) {
      const clean = String(value || '').replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
      return clean ? clean.charAt(0).toUpperCase() + clean.slice(1) : '';
    }

    item(value, label) {
      return { value: this.slug(value), label: label || this.labelize(value) };
    }

    unique(items) {
      const map = new Map();
      items.filter((item) => item && item.value).forEach((item) => {
        if (!map.has(item.value)) map.set(item.value, item);
      });
      return [...map.values()].sort((a, b) => a.label.localeCompare(b.label, document.documentElement.lang, { numeric: true }));
    }

    tags(product) {
      if (Array.isArray(product.tags)) return product.tags;
      return String(product.tags || '').split(',').map((tag) => tag.trim()).filter(Boolean);
    }

    tagValues(product, prefixes) {
      const values = [];
      this.tags(product).forEach((tag) => {
        const normalizedTag = this.normalize(tag);
        prefixes.forEach((prefix) => {
          if (!normalizedTag.startsWith(this.normalize(prefix))) return;
          const depth = prefix.split(':').length - 1;
          const value = tag.split(':').slice(depth).join(':').trim();
          if (value) values.push(this.item(value));
        });
      });
      return this.unique(values);
    }

    optionValues(product, names) {
      const values = [];
      (product.options || []).forEach((option) => {
        const name = this.normalize(option.name);
        if (!names.some((candidate) => name.includes(candidate))) return;
        (option.values || []).forEach((value) => {
          if (value && this.normalize(value) !== 'default title') values.push(this.item(value));
        });
      });
      return this.unique(values);
    }

    productText(product) {
      return this.normalize([product.title, product.vendor, product.product_type, ...this.tags(product)].join(' '));
    }

    inferCategory(product) {
      const tagged = this.tagValues(product, ['guide:categorie:', 'guide:category:']);
      if (tagged.length) return tagged;
      const text = this.productText(product);
      const productType = this.normalize(product.product_type);
      if (productType === 'cartouche' || productType === 'pods') return [this.item('puffs', this.labels.categoryPuffs)];
      if (/(puff|chicha)/.test(text)) return [this.item('puffs', this.labels.categoryPuffs)];
      if (/(base|arome|arôme|concentre|concentré|booster|nicotine)/.test(text) && !/(e-liquide|eliquide)/.test(this.normalize(product.product_type))) return [this.item('diy', this.labels.categoryDiy)];
      if (/(resistance|résistance|coil|kit|box|mod|atomiseur|clearomiseur|reservoir|réservoir|accu|batterie|accessoire|cartouche|pod)/.test(text)) return [this.item('materiel', this.labels.categoryHardware)];
      if (/(e-liquide|eliquide|liquide)/.test(text)) return [this.item('e-liquides', this.labels.categoryEliquids)];
      return [this.item('materiel', this.labels.categoryHardware)];
    }

    inferSubcategory(product, category) {
      const tagged = this.tagValues(product, ['guide:sous-categorie:', 'guide:sous-catégorie:', 'guide:type:']);
      if (tagged.length) return tagged;
      const text = this.productText(product);
      if (category === 'puffs') {
        const productType = this.normalize(product.product_type);
        if (/(pre-rempli|pré-rempli|prerempli|prérempli|prefilled|cartouche)/.test(text)) return [this.item('pods-preremplis', this.labels.subcategoryPrefilled)];
        if (/(remplissable|rechargeable|refillable)/.test(text)) return [this.item('pods-remplissables', this.labels.subcategoryRefillable)];
        if (productType === 'cartouche' || productType === 'pods') return [this.item('pods-preremplis', this.labels.subcategoryPrefilled)];
        return [this.item('a-liquide', this.labels.subcategoryLiquid)];
      }
      if (category === 'diy') {
        if (/(arome|arôme|concentre|concentré)/.test(text)) return [this.item('aromes', this.labels.subcategoryFlavors)];
        if (/(nicotine|booster)/.test(text)) return [this.item('nicotines', this.labels.subcategoryNicotine)];
        return [this.item('bases', this.labels.subcategoryBases)];
      }
      if (category === 'materiel') {
        if (/(resistance|résistance|coil)/.test(text)) return [this.item('resistances', this.labels.subcategoryCoils)];
        if (/(kit)/.test(text)) return [this.item('kits-complets', this.labels.subcategoryKits)];
        if (/(box|mod)/.test(text)) return [this.item('boxs', this.labels.subcategoryBoxes)];
        if (/(atomiseur|clearomiseur|reservoir|réservoir|tank)/.test(text)) return [this.item('atomiseurs', this.labels.subcategoryAtomizers)];
        if (/(accu|batterie)/.test(text)) return [this.item('accus', this.labels.subcategoryBatteries)];
        return [this.item('accessoires', this.labels.subcategoryAccessories)];
      }
      return [];
    }

    extractFormats(product) {
      const values = [
        ...this.tagValues(product, ['guide:format:', 'format:', 'contenance:']),
        ...this.optionValues(product, ['format', 'contenance', 'volume']),
      ];
      const text = [product.title, ...(product.variants || []).map((variant) => variant.title)].join(' ');
      [...text.matchAll(/(\d+(?:[.,]\d+)?)\s*ml\b/gi)].forEach((match) => {
        const number = Number(match[1].replace(',', '.'));
        if (number > 0 && number <= 2000) values.push(this.item(`${number}-ml`, `${number} ml`));
      });
      return this.unique(values);
    }

    extractNicotine(product) {
      const numbers = [];
      const tagged = this.tagValues(product, ['guide:nicotine:', 'nicotine:', 'taux:']);
      tagged.forEach((entry) => {
        const match = entry.label.match(/\d+(?:[.,]\d+)?/);
        if (match) numbers.push(Number(match[0].replace(',', '.')));
      });
      const options = this.optionValues(product, ['nicotine', 'taux', 'dosage']);
      options.forEach((entry) => {
        if (/sans|zero|zéro/.test(this.normalize(entry.label))) numbers.push(0);
        const match = entry.label.match(/\d+(?:[.,]\d+)?/);
        if (match) numbers.push(Number(match[0].replace(',', '.')));
      });
      const text = [product.title, ...(product.variants || []).map((variant) => variant.title)].join(' ');
      [...text.matchAll(/(\d+(?:[.,]\d+)?)\s*mg(?:\s*\/\s*ml)?/gi)].forEach((match) => numbers.push(Number(match[1].replace(',', '.'))));
      return [...new Set(numbers.filter((number) => number >= 0 && number <= 20))].sort((a, b) => a - b);
    }

    extractPuffs(product, category) {
      const values = this.tagValues(product, ['guide:taffs:', 'guide:puffs:', 'taffs:', 'puffs:', 'bouffees:', 'bouffées:']);
      const text = [product.title, ...(product.variants || []).map((variant) => variant.title)].join(' ');
      [...text.matchAll(/(\d[\d\s.]*)\s*(?:taffs?|puffs?|bouff[eé]es?)/gi)].forEach((match) => {
        const number = Number(match[1].replace(/[\s.]/g, ''));
        if (number > 0) values.push(this.item(`${number}`, new Intl.NumberFormat(document.documentElement.lang).format(number)));
      });
      if (category === 'puffs') {
        [...text.matchAll(/(\d+(?:[.,]\d+)?)\s*k\b/gi)].forEach((match) => {
          const number = Number(match[1].replace(',', '.')) * 1000;
          if (number > 0) values.push(this.item(`${number}`, new Intl.NumberFormat(document.documentElement.lang).format(number)));
        });
      }
      return this.unique(values);
    }

    hydrateProduct(product) {
      const category = this.inferCategory(product);
      const primaryCategory = category[0]?.value;
      const subcategory = this.inferSubcategory(product, primaryCategory);
      const metafields = this.flavorMap.get(product.handle) || {};
      const flavor = metafields.flavor || [];
      const taste = metafields.taste || [];
      let model = this.unique([
        ...this.tagValues(product, ['guide:modele:', 'guide:modèle:', 'modele:', 'modèle:']),
        ...this.optionValues(product, ['modele', 'modèle', 'model']),
      ]);
      if (!model.length && subcategory.some((item) => item.value === 'resistances')) model = [this.item(product.handle, product.title)];
      product.dimensions = {
        entry: [
          this.item('type', this.labels.pathType),
          this.item('brand', this.labels.pathBrand),
        ],
        category,
        subcategory,
        flavor,
        taste,
        format: this.extractFormats(product),
        nicotine: this.extractNicotine(product),
        puffs: this.extractPuffs(product, primaryCategory),
        brand: this.unique([
          ...this.tagValues(product, ['guide:marque:', 'marque:', 'brand:']),
          ...(product.vendor ? [this.item(product.vendor, product.vendor)] : []),
        ]),
        model,
      };
      return product;
    }

    getFlow() {
      const entry = this.state.entry?.[0];
      const category = this.state.category?.[0];
      const subcategory = this.state.subcategory?.[0];
      const entryStep = { key: 'entry' };
      const flavorStep = { key: this.flavorMode, multi: true, flavorFilter: true };
      if (!entry) return [entryStep];
      if (entry === 'brand') return [entryStep, { key: 'brand' }];
      if (!category) return [entryStep, { key: 'category' }];
      if (category === 'e-liquides') return [
        entryStep,
        flavorStep,
        { key: 'format' },
        { key: 'nicotine', range: true },
      ];
      if (category === 'puffs') return [
        entryStep,
        { key: 'subcategory' },
        ...(subcategory ? [flavorStep, { key: 'puffs' }] : []),
      ];
      if (category === 'diy') {
        const flow = [entryStep, { key: 'subcategory' }];
        if (subcategory === 'bases') flow.push({ key: 'format' });
        if (subcategory === 'aromes') flow.push(flavorStep, { key: 'format' });
        return flow;
      }
      if (category === 'materiel') {
        const flow = [entryStep, { key: 'subcategory' }];
        if (subcategory === 'resistances') flow.push({ key: 'brand', optional: true }, { key: 'model' });
        if (['kits-complets', 'boxs', 'atomiseurs'].includes(subcategory)) flow.push({ key: 'brand', optional: true });
        return flow;
      }
      return [
        entryStep,
        { key: 'subcategory', optional: true },
        { ...flavorStep, optional: true },
        { key: 'format', optional: true },
        { key: 'nicotine', range: true, optional: true },
        { key: 'puffs', optional: true },
        { key: 'brand', optional: true },
        { key: 'model', optional: true },
      ];
    }

    matches(product, excludedKey, provisional) {
      const state = { ...this.state };
      if (excludedKey) delete state[excludedKey];
      Object.assign(state, provisional || {});
      return Object.entries(state).every(([key, selected]) => {
        if (!selected || (Array.isArray(selected) && selected.length === 0)) return true;
        const values = product.dimensions[key] || [];
        if (key === 'nicotine') return values.some((value) => value >= selected.min && value <= selected.max);
        return selected.some((value) => values.some((item) => item.value === value));
      });
    }

    filteredProducts(excludedKey, provisional) {
      return this.products.filter((product) => this.matches(product, excludedKey, provisional));
    }

    availableValues(key) {
      if (key === 'entry') return [
        this.item('type', this.labels.pathType),
        this.item('brand', this.labels.pathBrand),
      ];
      return this.unique(this.filteredProducts(key).flatMap((product) => product.dimensions[key] || []).filter((value) => typeof value !== 'number'));
    }

    availableNumbers(key) {
      return [...new Set(this.filteredProducts(key).flatMap((product) => product.dimensions[key] || []).filter((value) => typeof value === 'number'))].sort((a, b) => a - b);
    }

    nextStep() {
      const flow = this.getFlow();
      for (const step of flow) {
        if (Object.prototype.hasOwnProperty.call(this.state, step.key)) continue;
        const count = step.flavorFilter
          ? Math.max(this.availableValues('flavor').length, this.availableValues('taste').length)
          : step.range
            ? this.availableNumbers(step.key).length
            : this.availableValues(step.key).length;
        if (count > 0) return step;
      }
      return null;
    }

    render() {
      this.renderSummary();
      const products = this.filteredProducts();
      if (this.history.length && products.length === 1 && this.dataset.autoRedirect === 'true' && !this.config.designMode) {
        window.location.assign(this.productUrl(products[0]));
        return;
      }
      const next = this.nextStep();
      this.updateJourney(next, products.length);
      if (next) this.renderStep(next);
      else this.renderResults(products);
      this.backButton.hidden = this.history.length === 0;
      this.resetButton.hidden = this.history.length === 0;
    }

    updateJourney(next, count) {
      const flow = this.getFlow();
      const total = Math.max(flow.length, 1);
      const current = next ? Math.min(this.history.length + 1, total) : total;
      const routeIsKnown = Boolean(this.state.entry?.[0])
        && (this.state.entry[0] === 'brand' || Boolean(this.state.category?.[0]));
      const progressTotal = routeIsKnown ? total : 5;
      const progress = next ? Math.max(8, (this.history.length / progressTotal) * 100) : 100;
      this.progressFill.style.width = `${progress}%`;
      this.progressText.textContent = routeIsKnown || !next
        ? this.labels.stepOf.replace('[current]', current).replace('[total]', total)
        : this.labels.step.replace('[current]', this.history.length + 1);
      this.liveCount.textContent = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR').format(count);
    }

    renderSummary() {
      this.summary.replaceChildren();
      if (!this.history.length) {
        const empty = document.createElement('li');
        empty.className = 'product-finder__summary-empty';
        empty.textContent = this.labels.startHere;
        this.summary.append(empty);
        return;
      }
      this.history.forEach((key, index) => {
        const selected = this.state[key];
        const labels = key === 'nicotine'
          ? [`${selected.min}–${selected.max} mg/ml`]
          : selected.map((value) => this.findLabel(key, value));
        const item = document.createElement('li');
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = `${this.labels[key]} : ${labels.length ? labels.join(', ') : this.labels.allValues}`;
        button.addEventListener('click', () => {
          this.history.slice(index).forEach((historyKey) => delete this.state[historyKey]);
          this.history = this.history.slice(0, index);
          this.render();
        });
        item.append(button);
        this.summary.append(item);
      });
    }

    findLabel(key, value) {
      const found = this.products.flatMap((product) => product.dimensions[key] || []).find((item) => item.value === value);
      return found?.label || this.labelize(value);
    }

    renderStep(step) {
      this.currentStep = step;
      this.pending = new Set();
      this.step.dataset.stepKey = step.key;
      this.results.hidden = true;
      this.step.hidden = false;
      this.choices.hidden = Boolean(step.range);
      this.rangePanel.hidden = !step.range;
      this.flavorModeControl.hidden = !step.flavorFilter;
      this.flavorModeControl.querySelectorAll('[data-flavor-mode-value]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.flavorModeValue === this.flavorMode));
      });
      this.choiceSearchWrap.hidden = true;
      this.choiceSearch.value = '';
      this.actions.hidden = !(step.multi || step.range || step.optional);
      this.querySelector('[data-step-count]').textContent = this.labels.step.replace('[current]', this.history.length + 1);
      this.querySelector('[data-step-title]').textContent = this.labels[step.key];
      this.querySelector('[data-step-help]').textContent = this.labels[`${step.key}Help`];
      const allButton = this.querySelector('[data-step-all]');
      const continueButton = this.querySelector('[data-step-continue]');
      allButton.textContent = step.key === 'brand' ? this.labels.allBrands : this.labels.allValues;
      allButton.hidden = !(step.multi || step.optional);
      continueButton.hidden = !(step.multi || step.range);
      continueButton.disabled = false;
      continueButton.textContent = this.labels.continue;
      this.choices.replaceChildren();
      if (step.range) {
        const numbers = this.availableNumbers(step.key);
        this.rangeMin.value = Math.max(0, Math.floor(Math.min(...numbers)));
        this.rangeMax.value = Math.min(20, Math.ceil(Math.max(...numbers)));
        this.syncRange();
      } else {
        const values = this.availableValues(step.key);
        this.choiceSearchWrap.hidden = values.length <= 12;
        values.forEach((item) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'product-finder__choice';
          button.dataset.value = item.value;
          button.dataset.choiceKey = step.key;
          button.setAttribute('aria-pressed', 'false');
          const icon = document.createElement('span');
          icon.className = 'product-finder__choice-icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.textContent = this.choiceIcon(step.key, item.value, item.label);
          const copy = document.createElement('span');
          copy.className = 'product-finder__choice-copy';
          const label = document.createElement('span');
          label.className = 'product-finder__choice-label';
          label.textContent = item.label;
          const descriptionText = this.choiceDescription(step.key, item.value);
          if (descriptionText) {
            const description = document.createElement('span');
            description.className = 'product-finder__choice-description';
            description.textContent = descriptionText;
            copy.append(label, description);
          } else copy.append(label);
          const count = document.createElement('small');
          const matches = this.filteredProducts(step.key, { [step.key]: [item.value] }).length;
          count.textContent = this.matchLabel(matches);
          copy.append(count);
          const arrow = document.createElement('span');
          arrow.className = 'product-finder__choice-arrow';
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = step.multi ? '✓' : '→';
          button.append(icon, copy, arrow);
          button.addEventListener('click', () => {
            if (step.multi) {
              if (this.pending.has(item.value)) this.pending.delete(item.value);
              else this.pending.add(item.value);
              button.setAttribute('aria-pressed', String(this.pending.has(item.value)));
              this.updateContinueCount();
            } else {
              this.state[step.key] = [item.value];
              this.history.push(step.key);
              this.render();
            }
          });
          this.choices.append(button);
        });
        if (step.multi) this.updateContinueCount();
      }
      requestAnimationFrame(() => this.querySelector('[data-step-title]').focus?.());
    }

    choiceIcon(key, value, label) {
      const icons = {
        'entry:type': '01', 'entry:brand': 'A–Z',
        'category:e-liquides': 'EL', 'category:puffs': 'PF',
        'category:diy': 'DIY', 'category:materiel': 'MT',
      };
      return icons[`${key}:${value}`] || String(label || value).trim().slice(0, 2).toUpperCase();
    }

    choiceDescription(key, value) {
      const descriptions = {
        'entry:type': this.labels.pathTypeHelp,
        'entry:brand': this.labels.pathBrandHelp,
        'category:e-liquides': this.labels.categoryEliquidsHelp,
        'category:puffs': this.labels.categoryPuffsHelp,
        'category:diy': this.labels.categoryDiyHelp,
        'category:materiel': this.labels.categoryHardwareHelp,
      };
      return descriptions[`${key}:${value}`] || '';
    }

    setFlavorMode(mode) {
      if (!['flavor', 'taste'].includes(mode) || mode === this.flavorMode) return;
      this.flavorMode = mode;
      this.renderStep({ ...this.currentStep, key: mode, flavorFilter: true });
    }

    filterChoices() {
      const query = this.normalize(this.choiceSearch.value);
      this.choices.querySelectorAll('[data-value]').forEach((button) => {
        button.hidden = Boolean(query) && !this.normalize(button.textContent).includes(query);
      });
    }

    syncRange(changed) {
      let min = Number(this.rangeMin.value);
      let max = Number(this.rangeMax.value);
      if (min > max) {
        if (changed === 'min') max = min;
        else min = max;
      }
      this.rangeMin.value = min;
      this.rangeMax.value = max;
      this.querySelector('[data-range-min-output]').textContent = min;
      this.querySelector('[data-range-max-output]').textContent = max;
      this.updateContinueCount();
    }

    updateContinueCount() {
      const button = this.querySelector('[data-step-continue]');
      let provisional;
      if (this.currentStep.range) provisional = { [this.currentStep.key]: { min: Number(this.rangeMin.value), max: Number(this.rangeMax.value) } };
      else provisional = { [this.currentStep.key]: [...this.pending] };
      const count = this.filteredProducts(this.currentStep.key, provisional).length;
      button.textContent = `${this.labels.continue} · ${this.matchLabel(count)}`;
      button.disabled = count === 0;
    }

    matchLabel(count) {
      return (count === 1 ? this.labels.oneMatch : this.labels.matches).replace('[count]', count);
    }

    commitStep() {
      const key = this.currentStep.key;
      if (this.currentStep.range) this.state[key] = { min: Number(this.rangeMin.value), max: Number(this.rangeMax.value) };
      else this.state[key] = [...this.pending];
      this.history.push(key);
      this.render();
    }

    skipStep() {
      this.state[this.currentStep.key] = [];
      this.history.push(this.currentStep.key);
      this.render();
    }

    goBack() {
      const key = this.history.pop();
      if (key) delete this.state[key];
      this.render();
    }

    reset() {
      this.state = {};
      this.history = [];
      this.flavorMode = 'flavor';
      this.render();
    }

    renderResults(products) {
      this.step.hidden = true;
      this.results.hidden = false;
      this.querySelector('[data-results-title]').textContent = this.labels.resultsTitle;
      this.querySelector('[data-results-count]').textContent = this.matchLabel(products.length);
      const grid = this.querySelector('[data-results-grid]');
      const empty = this.querySelector('[data-results-empty]');
      grid.replaceChildren();
      empty.hidden = products.length > 0;
      grid.hidden = products.length === 0;
      products.forEach((product) => grid.append(this.productCard(product)));
      this.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    productUrl(product) {
      return `${this.config.rootUrl}products/${encodeURIComponent(product.handle)}`;
    }

    productCard(product) {
      const article = document.createElement('article');
      article.className = 'product-card product-finder__card';
      const media = document.createElement('a');
      media.className = 'product-card__media';
      media.href = this.productUrl(product);
      media.setAttribute('aria-label', product.title);
      const imageData = product.images?.[0];
      if (imageData?.src) {
        const image = document.createElement('img');
        image.src = imageData.src;
        image.alt = imageData.alt || product.title;
        image.loading = 'lazy';
        image.width = imageData.width || 600;
        image.height = imageData.height || 600;
        media.append(image);
      }
      const available = (product.variants || []).filter((variant) => variant.available);
      if (!available.length) {
        const badge = document.createElement('span');
        badge.className = 'product-card__badge';
        badge.textContent = this.labels.soldOut;
        media.append(badge);
      }
      const body = document.createElement('div');
      body.className = 'product-card__body';
      if (this.dataset.showVendor === 'true' && product.vendor) {
        const vendor = document.createElement('p');
        vendor.className = 'eyebrow';
        vendor.textContent = product.vendor;
        body.append(vendor);
      }
      const title = document.createElement('h3');
      const titleLink = document.createElement('a');
      titleLink.href = this.productUrl(product);
      titleLink.textContent = product.title;
      title.append(titleLink);
      body.append(title);
      const price = document.createElement('p');
      price.className = 'product-card__price';
      const prices = available.map((variant) => Number(variant.price)).filter(Number.isFinite);
      const lowest = prices.length ? Math.min(...prices) : Number(product.variants?.[0]?.price || 0);
      const money = this.formatMoney(lowest);
      price.textContent = new Set(prices).size > 1 ? this.labels.fromPrice.replace('[price]', money) : money;
      body.append(price);
      if (this.dataset.showQuickAdd === 'true') {
        const action = document.createElement('div');
        action.className = 'product-card__action';
        if (product.variants?.length === 1 && available.length === 1) {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = this.labels.quickAdd;
          button.addEventListener('click', () => this.addToCart(button, available[0].id));
          action.append(button);
        } else if (available.length) {
          const link = document.createElement('a');
          link.className = 'button-secondary';
          link.href = this.productUrl(product);
          link.textContent = this.labels.chooseOptions;
          action.append(link);
        } else {
          const button = document.createElement('button');
          button.type = 'button';
          button.disabled = true;
          button.textContent = this.labels.soldOut;
          action.append(button);
        }
        body.append(action);
      }
      article.append(media, body);
      return article;
    }

    async addToCart(button, variantId) {
      const previous = button.textContent;
      button.disabled = true;
      try {
        const response = await fetch(this.config.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        });
        if (!response.ok) throw new Error();
        const cartResponse = await fetch(this.config.cartUrl, { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: this.id || 'product-finder', data: { source: 'product-finder', itemCount: cart.item_count } },
        }));
        button.textContent = this.labels.added;
        setTimeout(() => {
          button.textContent = previous;
          button.disabled = false;
        }, 1600);
      } catch (error) {
        button.textContent = this.labels.addError;
        setTimeout(() => {
          button.textContent = previous;
          button.disabled = false;
        }, 1800);
      }
    }

    formatMoney(value) {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: this.config.currency || 'EUR',
      }).format(Number(value || 0));
    }
  }

  if (!customElements.get('product-finder')) customElements.define('product-finder', ProductFinder);

  } catch(e) { console.error(e); }
})();
})();
